import { render, staticRenderFns } from "./FaqAccordionCollapse.vue?vue&type=template&id=6f949168&"
import script from "./FaqAccordionCollapse.vue?vue&type=script&lang=js&"
export * from "./FaqAccordionCollapse.vue?vue&type=script&lang=js&"
import style0 from "./FaqAccordionCollapse.vue?vue&type=style&index=0&lang=sass&rel=stylesheet%2Fsass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports